export enum DashboardActionTypes {
    DASHBOARD_OUTLETS = '@@dashboard/DASHBOARD_OUTLETS',
    DASHBOARD_OUTLETS_SUCCESS = '@@dashboard/DASHBOARD_OUTLETS_SUCCESS',
    DASHBOARD_OUTLETS_ERROR = '@@dashboard/DASHBOARD_OUTLETS_ERROR',
}
